export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#1a3a4a] text-white pt-16 pb-8 relative overflow-hidden">
      {/* Decorative background text */}
      <div className="absolute bottom-0 left-0 right-0 text-center pointer-events-none select-none overflow-hidden">
        <span className="text-[120px] md:text-[180px] font-black text-white/5 leading-none tracking-widest">
          ZAFER
        </span>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-anchor-line text-[#e8734a] text-xl"></i>
              </div>
              <span className="font-bold text-lg">Balıkçı Zafer</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Aliağa'nın en taze balık adresi. Her gün denizden sofraya, aile sıcaklığıyla.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-instagram-line", "ri-facebook-line", "ri-whatsapp-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-[#e8734a] transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm mb-5 text-white/90">Hızlı Linkler</h4>
            <ul className="space-y-3">
              {[
                { label: "Ana Sayfa", href: "#hero" },
                { label: "Hakkımızda", href: "#hakkimizda" },
                { label: "Menü", href: "#menu" },
                { label: "Galeri", href: "#galeri" },
                { label: "İletişim", href: "#iletisim" },
              ].map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="text-white/60 text-sm hover:text-[#e8734a] transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm mb-5 text-white/90">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-white/60 text-sm">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-[#e8734a] text-xs"></i>
                </div>
                Kazımdimdirik Mah. Atatürk Cad. No:101/A, Aliağa, İzmir
              </li>
              <li className="flex items-center gap-2 text-white/60 text-sm">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-[#e8734a] text-xs"></i>
                </div>
                +90 (232) 000 00 00
              </li>
              <li className="flex items-center gap-2 text-white/60 text-sm">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-[#e8734a] text-xs"></i>
                </div>
                Her gün 11:00 - 22:00
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-semibold text-sm mb-5 text-white/90">Haberdar Olun</h4>
            <p className="text-white/60 text-sm mb-4">Günlük menü ve kampanyalardan haberdar olun</p>
            <div className="flex items-center gap-0">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 bg-white/10 border border-white/20 rounded-l-full px-4 py-2.5 text-sm text-white placeholder-white/40 focus:outline-none focus:border-[#e8734a] min-w-0"
              />
              <button className="bg-[#e8734a] hover:bg-[#d4623a] transition-colors duration-200 px-4 py-2.5 rounded-r-full cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            &copy; 2024 Balıkçı Zafer. Tüm hakları saklıdır.
          </p>
          <p className="text-white/40 text-xs">
            İzmir Aliağa &bull; Aile İşletmesi
          </p>
        </div>
      </div>
    </footer>
  );
}
